module.exports = __webpack_public_path__ + "img/kuaitui.bdde9381.png";